export default __webpack_public_path__ + "static/media/image.fixmy-lk.77697101.png";